import React, { useCallback } from 'react';
import { useSelectShareUsers } from 'app/store/shareUsers/selectors';
import IndigoUser from 'communication/types/IndigoUser';
import { AutoSuggest } from '@instinet-analytics/core-lib';
import Highlighter from 'react-highlight-words';

import './AutoSuggestShareUsers.scss';

export interface AutoSuggestShareUsersProps {
    error?: boolean;
    value: string;
    onChange: (username: string) => void;
    onEnter: () => void;
}

export default function AutoSuggestShareUsers(
    props: AutoSuggestShareUsersProps
) {
    const { onChange, value, error, onEnter } = props;

    const candidates = useSelectShareUsers();

    const onGetSuggestion = useCallback(
        (c: IndigoUser) => `${c.username}${c.name}${c.clientName}${c.id}`,
        []
    );

    const onGetSuggestionValue = useCallback((c: IndigoUser) => c.username, []);

    const renderSuggestionsHeader = useCallback(
        () => (
            <>
                <div className="suggestion-cell id">ID</div>
                <div className="suggestion-cell name">NAME</div>
                <div className="suggestion-cell client">CLIENT</div>
                <div className="suggestion-cell user">USER</div>
            </>
        ),
        []
    );

    const renderSuggestion = useCallback(
        (s: IndigoUser) => {
            const highlight = (val: string) => (
                <Highlighter
                    searchWords={[value]}
                    autoEscape={true}
                    textToHighlight={val ?? ''}
                    highlightTag={'span'}
                    highlightClassName={'match'}
                />
            );
            return (
                <div className="suggestion-row" key={s.id}>
                    <div className="suggestion-cell id" title={s.id}>
                        {highlight(s.id)}
                    </div>
                    <div className="suggestion-cell name" title={s.name}>
                        {highlight(s.name)}
                    </div>
                    <div
                        className="suggestion-cell client"
                        title={s.clientName}
                    >
                        {highlight(s.clientName)}
                    </div>
                    <div className="suggestion-cell user" title={s.username}>
                        {highlight(s.username)}
                    </div>
                </div>
            );
        },
        [value]
    );

    return (
        <AutoSuggest
            autoFocus={true}
            className="AutoSuggestShareUsers"
            candidates={candidates}
            error={error}
            placeholder={'Enter username'}
            value={value}
            getComparisonString={onGetSuggestion}
            getCandidateValue={onGetSuggestionValue}
            onChange={onChange}
            renderSuggestion={renderSuggestion}
            renderSuggestionsHeader={renderSuggestionsHeader}
            onEnter={onEnter}
        ></AutoSuggest>
    );
}
